import { useReducer } from 'react'
import { REPORT_SEVERITY } from '../../../hooks/useReportTypes'

const getInitialFiltersState = isAllOriginalGranted => {
    return {
        from: null,
        to: null,
        report_types: [],
        operation_modes: [],
        device_types: [],
        is_assigned: !isAllOriginalGranted,
        search: '',
        sort_by: ''
    }
}

const filterReducer = (state, action) => {
    switch (action.type) {
        case 'is_assigned': {
            return {
                ...state,
                is_assigned: action.value
            }
        }
        case 'from':
            return {
                ...state,
                from: action.from
            }
        case 'to':
            return {
                ...state,
                to: action.to
            }
        case 'status': {
            return {
                ...state,
                report_types: action.value
            }
        }
        case 'operationMode': {
            return {
                ...state,
                ...action.value
            }
        }
        case 'search': {
            return {
                ...state,
                search: action.value
            }
        }
        case 'sort': {
            return {
                ...state,
                sort_by: action.sort_by
            }
        }
        default:
            return state
    }
}

export const useDevicesFilters = (initialFilters, withAssignedToggle) => {
    const filters = {
        ...getInitialFiltersState(withAssignedToggle),
        ...initialFilters
    }
    if (!withAssignedToggle) filters.is_assigned = true
    return useReducer(filterReducer, filters)
}

export const STATUS_SEVERITY_MAP = {
    [REPORT_SEVERITY.info]: ['0', '1', '3', '11', '25'],
    [REPORT_SEVERITY.inactive]: ['12'],
    [REPORT_SEVERITY.critical]: ['2', '5', '16', '19', '20', '22', '23', '24'],
    [REPORT_SEVERITY.warning]: ['4', '13', '15', '17', '18', '21']
}

export const URL_STATUS_SEVERITY_MAP = {
    [REPORT_SEVERITY.info]: ['1', '25'], // the difference
    [REPORT_SEVERITY.inactive]: ['12'],
    [REPORT_SEVERITY.critical]: ['2', '5', '16', '19', '20', '22', '23', '24'],
    [REPORT_SEVERITY.warning]: ['4', '13', '15', '17', '18', '21']
}
